import React, { useContext, useEffect, useState } from "react";
import { Switch, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Login from "./components/Login";
import Signup from "./components/Signup";
import Logout from "./components/Logout";
import UserContext from "./context/users/UserContext";
import MobileNav from "./components/MobileNav";
import Errorpage from "./components/Errorpage";
import uiContext from "./context/ui/uiContext";
import Category from "./components/Category";
import LoadingBar from 'react-top-loading-bar'
import ReadBlog from "./components/ReadBlog";
import Dashboard from "./components/Dashboard";
import Footer from "./components/Footer";



function App(props) {
  const widthContext = useContext(uiContext);

  //scrolls to top every time when page is switched
  const location = useLocation();  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const responsiveCheck = () => {
    let width = window.innerWidth;
    if (width > 540 && width <= 605) {
      widthContext.setWidthSize(() => 1);
      widthContext.setSideBar(0);
    } else if (width > 605 && width <= 864) {
      widthContext.setWidthSize(() => 2);
      widthContext.setSideBar(0);
    } else if (width > 865) {
      widthContext.setWidthSize(() => 3);
      widthContext.setSideBar(0);
    } else if (width <= 540) {
      widthContext.setWidthSize(() => 0);
      widthContext.setSideBar(0);
    }
  };

  const context = useContext(UserContext);
  const { setLoggedIn, updateCurrentUser } = context;
  useEffect(() => {
    responsiveCheck();
    let authToken = localStorage.getItem("auth-token") ? true : false;
    if (authToken) {
      setLoggedIn(() => true);
      updateCurrentUser();
    }
    // eslint-disable-next-line
  }, []);

  window.addEventListener("resize", () => {
    responsiveCheck();
  });

  const [progress,setProgress]=useState(0)
  return (
    <div>
      {/* <Totop/> */}
      <LoadingBar
        color='#43ef30'
        height={3}
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
      />
      <Navbar />
      <MobileNav />
      <div class="body-container">
        <Switch>
          <Route path="/" exact>
            <Home setProgress={setProgress} />
          </Route>
          <Route path="/login" exact>
            <Login setProgress={setProgress} />
          </Route>
          <Route path="/signup" exact>
            <Signup setProgress={setProgress} />
          </Route>
          <Route path="/logout" exact>
            <Logout setProgress={setProgress} />
          </Route>
          <Route path="/category/general" exact>
            <Category category="general" setProgress={setProgress}/>
          </Route>
          <Route path="/category/technology" exact>
            <Category category="technology" setProgress={setProgress}/>
          </Route>
          <Route path="/category/sports" exact>
            <Category category="sports" setProgress={setProgress}/>
          </Route>
          <Route path="/category/health" exact>
            <Category category="health" setProgress={setProgress}/>
          </Route>
          <Route path="/category/movies" exact>
            <Category category="movies" setProgress={setProgress}/>
          </Route>
          <Route path="/category/bio" exact>
            <Category category="bio" setProgress={setProgress}/>
          </Route>
          <Route path="/blog/:slug" exact>
            <ReadBlog  setProgress={setProgress}/>
          </Route>
          <Route path="/dashboard/:path" exact>
            <Dashboard  setProgress={setProgress}/>
          </Route>
          <Route path="/dashboard" exact>
            <Dashboard  setProgress={setProgress}/>
          </Route>
          <Route>
            <Errorpage/>
          </Route>
        </Switch>
      </div>
      <Footer/>
    </div>
  );
}

export default App;
